module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("social_apps_row", [["li",{"class":"border-color-1"},[["a",{"href":"","title":"","rel":"nofollow"},[["if",{"notempty":"","addattr":"target:blank"},[],[["newTarget","notempty",true]]],["i",{"class":"icon-au_&&0&& text-color-1"},[],[["elementClass","class"]]]],[["pageUrl","href",true],["title","title",true,[{"name":"replace_text","params":["Twitter","Twitter "]}]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/layout/home/socialapps.tpl
// module id = 1175
// module chunks = 4